<template>
	<div>
		<div class="row">
			<div class="input-field col s12 m12 12 x12">
				<label>Nome</label>
			</div>
			<div class="input-field col s12 m12 l12 x12">
				{{item.nome}}
			</div>
		</div>

		<div class="row">
			<template v-for="(valor, index) in item.valores" >
				<div class="input-field col s2 m2 2 x2">
					<input :id="index" :name="index" type="number" class="validate" :value='valor' min='-1.0' max='9.9' step='0.25' required>
					<label>{{index}}</label>
				</div>
			</template>
		</div>
		
		<div class="row">	
			<div class="input-field col s6 m6 l3 xl3">
				<button type="submit" class="btn"><i class="material-icons left">save</i>Salvar</button>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
      name: "VueAvalFormItemForm",
      props: [
        'aval_item',
      ],
      data () {
        return {
          item: JSON.parse(this.aval_item),
        }
      },
    }
</script>
